import React from "react";
import DescriptionHtmlCode from "../HtmlCode/DescriptionHtmlCode";
import ShowOnlyText from "../HtmlCode/ShowOnlyText";

interface CustomTextAreaProps {
  label: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  isVersioned?: boolean;
  versionedValue?: string;
}

const CustomTextArea: React.FC<CustomTextAreaProps> = ({
  label,
  name,
  value,
  onChange,
  error,
  required = false,
  placeholder = "",
  disabled = false,
  isVersioned = false,
  versionedValue = "",
}) => {
  return (
    <div className="w-full mb-4">
      <label className="block mb-2 text-base font-medium">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      {isVersioned ? (
        <ShowOnlyText content={versionedValue} setContent={""} />
      ) : null}

      <DescriptionHtmlCode
        content={value}
        setContent={(newVal: string) => onChange(newVal)}
      />

      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default CustomTextArea;
